export const scope = [{ value: "OPCVM" }];
